import baseEvents from '../../base/config/baseEvents';

export default function AtcFlightsHeaderController(
    $scope,
    $rootScope,
    $controller,
    atcFlightsFactory,
    previousState,
) {
    'ngInject';

    $controller('atcFlightsHeaderBaseController', {
        $scope,
        atcFlightsFactory,
        previousState,
    });

    const vm = this;

    Object.assign(vm, {
        resetFilters,
    });

    function resetFilters() {
        $rootScope.$broadcast(baseEvents.CLEAR_FILTERS);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/controllers/atcFlightsHeaderController.js